export default "__VITE_ASSET__DeXd7Jsy__"